export const backwardCompatibility = (obj: {}, name: string, value: unknown): void => {
    if (obj) {
        const existing = obj[name];
        if (existing === undefined || existing === null) {
            obj[name] = value;
        }
    }
};